import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { ActiveUserStore } from '../../../stores/user/active-user.state';

@Component({
  selector: 'app-table-list-actions',
  standalone: true,
  imports: [ButtonModule, RouterLink],
  templateUrl: './table-list-actions.component.html',
  styleUrl: './table-list-actions.component.scss',
})
export class TableListActionsComponent {
  readonly activeUserStore = inject(ActiveUserStore);
  @Input() hideEdit = false;
  @Input() hideDelete = false;
  @Input() item: any;
  @Output() confirm = new EventEmitter<any>();
}
